// ----------------------------------------------------------------------------
// Component: Hero Carousel
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// Styles
import 'snippets/background-media/background-media';
import './_hero-carousel.scss';
